import { useLayoutEffect, useState } from "react";
import DEGULAR_BOLD_FONT_URL from "../../assets/fonts/degular-bold-base64";

const degularFont = new FontFace("Degular", `url(${DEGULAR_BOLD_FONT_URL})`);
degularFont.load().then((font) => document.fonts.add(font));

const initialData = {
  baseImageWidth: 703,
};

const generateAttributesStyle = (attributes, aspectRatio) => {
  if (!attributes) return;

  const { x = 0, y = 0, position } = attributes;

  switch (position) {
    case "north_west":
      return {
        top: `${Math.round(y / aspectRatio)}px`,
        left: `${Math.round(x / aspectRatio)}px`,
      };
    case "north_east":
      return {
        top: `${Math.round(y / aspectRatio)}px`,
        right: `${Math.round(x / aspectRatio)}px`,
      };
    case "south_west":
      return {
        bottom: `${Math.round(y / aspectRatio)}px`,
        left: `${Math.round(x / aspectRatio)}px`,
      };
    case "south_east":
      return {
        bottom: `${Math.round(y / aspectRatio)}px`,
        right: `${Math.round(x / aspectRatio)}px`,
      };
    case "north":
      return {
        top: "0px",
        left: "50%",
        WebkitTransform: "translateX(-50%)",
        transform: "translateX(-50%)",
      };
    case "west":
      return {
        left: "0px",
        WebkitTransform: "translateY(-50%)",
        transform: "translateY(-50%)",
      };
    case "south":
      return {
        bottom: "0px",
        left: "50%",
        WebkitTransform: "translateX(-50%)",
        transform: "translateX(-50%)",
      };
    case "east":
      return {
        right: "0px",
        top: "50%",
        WebkitTransform: "translateY(-50%)",
        transform: "translateY(-50%)",
      };
    case "center":
      return {
        right: "50%",
        top: "50%",
        WebkitTransform: "translate(50%, -50%)",
        transform: "translate(50%, -50%)",
      };

    default:
      return {
        top: `${Math.round(y / aspectRatio)}px`,
        left: `${Math.round(x / aspectRatio)}px`,
      };
  }
};

const useBannerCSS = (bannerEl, currentEvent) => {
  const [avatarCSS, setAvatarCSS] = useState();
  const [usernameCSS, setUsernameCSS] = useState();

  const imageAttribute = currentEvent.imageAttribute;
  const nameAttribute = currentEvent.nameAttribute;
  const shape = imageAttribute?.shape;

  useLayoutEffect(() => {
    const handleResize = () => {
      const bannerWidth = bannerEl?.offsetWidth ?? 1;

      const aspectRatio = initialData.baseImageWidth / bannerWidth;
      const imgAttributeStyle = generateAttributesStyle(
        imageAttribute,
        aspectRatio
      );
      const nameAttributeStyle = generateAttributesStyle(
        nameAttribute,
        aspectRatio
      );

      setAvatarCSS({
        width: `${Math.round(
          Number(imageAttribute?.width ?? 360) / aspectRatio
        )}px`,
        height: `${Math.round(
          Number(imageAttribute?.height ?? 360) / aspectRatio
        )}px`,
        lineHeight: `${Math.round(initialData?.avatarHeight / aspectRatio)}px`,
        borderRadius:
          shape?.toLowerCase() === "circle"
            ? "100%"
            : `${imageAttribute?.radius / aspectRatio || "0"}px`,
        ...imgAttributeStyle,
      });

      setUsernameCSS({
        width: `${Math.round(
          Number(nameAttribute?.width ?? 703) / aspectRatio
        )}px`,
        height: `${Math.round(
          Number(nameAttribute?.height ?? 40) / aspectRatio
        )}px`,
        fontFamily: "'Degular', sans-serif",
        fontWeight: nameAttribute?.fontWeight ?? "normal",
        fontSize: `${Math.round(
          Math.max(nameAttribute?.fontSize ?? 30, 48) / aspectRatio
        )}px`,
        color: nameAttribute?.textColor ?? "black",
        textAlign: nameAttribute?.textAlign ?? "center",
        textTransform: nameAttribute?.textTransform ?? null,
        top:
          nameAttribute?.textAlign === "fit"
            ? `${nameAttribute?.y - 10}px`
            : `${nameAttribute?.y}px`,
        left: `${nameAttribute?.x}px`,
        overflow: "hidden",

        // TODO temporary hack. Revisit this later.
        ...nameAttributeStyle,
      });
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [
    bannerEl?.offsetWidth,
    JSON.stringify(imageAttribute),
    JSON.stringify(nameAttribute),
  ]);

  return { avatarCSS, usernameCSS };
};

export default useBannerCSS;
